import Component from 'flarum/common/Component';
import SiteInfoTouRongServiceModal from "./modal/SiteInfoTouRongServiceModal";
import SiteInfoYouKePlanModal from "./modal/SiteInfoYouKePlanModal";
import SiteInfoJoinGroupModal from "./modal/SiteInfoJoinGroupModal";

export default class SiteInfoComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  view() {
    return (
      <div>
        <div className="u2diSiteInfoContainer">
          <span style="color:#ff0042" onclick={(e) => { window.open('https://jujianba.com','_blank'); }}>成交喜讯</span>
          <span style="color:rgb(252,128,4)" onclick={(e) => { app.modal.show(SiteInfoYouKePlanModal) }}>优客计划</span>
          <span style="color:rgb(161,126,255)" onclick={(e) => { app.modal.show(SiteInfoTouRongServiceModal) }}>投融服务</span>
          <span style="color:rgb(151,111,76)" onclick={(e) => { app.modal.show(SiteInfoJoinGroupModal) }}>联系我们</span>
        </div>
      </div>
    );
  }

}